import React, { useState } from "react";
import {
  Grid,
  Typography,
  ListItem,
  List,
  Paper,
  IconButton,
} from "@mui/material";
import InputField from "../FormComponents/InputField";

import DeleteIcon from "@mui/icons-material/Delete";

function ReturnBillItemComponent({
  billItems,
  setBillItemSet,
  qtyValidatingSet,
  setQtyValidatingSet,
}) {
  const [error, setError] = useState("");

  const removeItem = (index) => {
    setBillItemSet(billItems.filter((_, i) => i !== index));
    setQtyValidatingSet(qtyValidatingSet.filter((_, i) => i !== index));
  };

  const handleQtyChange = (value, index) => {
    // const enteredQty = parseFloat(value);
    const maxQty = parseFloat(qtyValidatingSet[index].bill_qty);

    console.log("Entered Qty: ", value);
    console.log("Max Qty: ", maxQty);
    if (!isNaN(value) && value <= maxQty) {
      setBillItemSet((prevBillItems) =>
        prevBillItems.map((item, i) =>
          i === index ? { ...item, bill_qty: value } : item
        )
      );
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} style={{ paddingTop: "10px" }}>
        <Typography variant="h7">Return Items</Typography>
      </Grid>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {billItems.map((item, index) => {
          return (
            <ListItem key={index} sx={{ width: "100%" }}>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <InputField
                    name="_itemCode"
                    value={item.imports.product_code}
                    type="text"
                    label="Item Code"
                    isdisabled={true}
                  />
                </Grid>
                <Grid item xs={3}>
                  <InputField
                    name="_item"
                    value={item.imports.itemName}
                    type="text"
                    label="Import Item"
                    isdisabled={true}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputField
                    name="_billUnit"
                    value={item.billUnit}
                    type="text"
                    label="Bill Unit"
                    isdisabled={true}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputField
                    name="bill_qty"
                    value={item.bill_qty}
                    type="number"
                    label="Return Qty"
                    isdisabled={false}
                    onChange={(event, newInputValue) =>
                      handleQtyChange(newInputValue, index)
                    }
                  />
                </Grid>
                {billItems.length !== 1 ? (
                  <Grid item xs={1}>
                    <IconButton
                      aria-label="delete"
                      onClick={() => removeItem(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                ) : null}
              </Grid>
            </ListItem>
          );
        })}
      </List>
    </Grid>
  );
}

export default ReturnBillItemComponent;
